var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 93,
    viewBox: "0 0 94 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 46.2583,
    r: 46.2583,
    fill: "#0976BC",
    fillOpacity: 0.26
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.672 27.5388C66.2408 27.16 65.6769 26.9678 65.1042 27.0044C64.5314 27.041 63.9966 27.3033 63.617 27.7338L59.5653 32.3921L58.2003 30.8538C57.8182 30.4228 57.2805 30.1613 56.7056 30.1267C56.1306 30.0922 55.5655 30.2875 55.1345 30.6696C54.7035 31.0517 54.442 31.5894 54.4075 32.1644C54.3729 32.7393 54.5682 33.3045 54.9503 33.7354L57.962 37.1154C58.167 37.3426 58.4178 37.5238 58.6979 37.647C58.978 37.7703 59.281 37.8328 59.587 37.8304C59.891 37.827 60.1908 37.7596 60.4671 37.6327C60.7433 37.5058 60.9897 37.3222 61.1903 37.0938L66.8453 30.5938C67.2267 30.1653 67.4226 29.6031 67.3902 29.0304C67.3577 28.4578 67.0994 27.9213 66.672 27.5388Z",
    fill: "#0976BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2412 59.8303C32.485 59.8303 31.8378 59.5613 31.2997 59.0232C30.7616 58.4851 30.4921 57.8375 30.4912 57.0803V40.5803C30.4912 39.8241 30.7607 39.1769 31.2997 38.6388C31.8387 38.1007 32.4859 37.8312 33.2412 37.8303H55.2412C55.9975 37.8303 56.6451 38.0998 57.1841 38.6388C57.7231 39.1778 57.9921 39.825 57.9912 40.5803V57.0803C57.9912 57.8366 57.7222 58.4842 57.1841 59.0232C56.646 59.5622 55.9984 59.8312 55.2412 59.8303H33.2412ZM44.2412 50.2053L55.2412 43.3303V40.5803L44.2412 47.4553L33.2412 40.5803V43.3303L44.2412 50.2053Z",
    fill: "#0976BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.9b17eb709f19698284b2a07e5daab108.svg";
export { ForwardRef as ReactComponent };